@if (mediaPicture?.desktopImage) {
<div class="image-container">
    <h-media-picture
        class="image"
        [mediaPicture]="mediaPicture"
        [mediaQueriesOptions]="MEDIA_QUERIES_OPTIONS"
        [preloadPoster]="false"></h-media-picture>
</div>
}
